angular.module('app').factory('ApiErrorService', function (toastr) {
    let fac = {
        error: error
    };
    function error(response /* ng.IHttpPromiseCallbackArg<any> or Error */) {
        showError(response);
    }
    function showError(response /* ng.IHttpPromiseCallbackArg<any> or Error */) {
        let title = 'Unexpected Error';
        let msg = 'An unexpected error has occured.';
        if (angular.isUndefined(response)) {
            msg = 'Invalid response received from the web server';
            toastr.error(msg);
            return;
        }
        let isError = angular.isDefined(response.message) && angular.isDefined(response.stack);
        if (isError === true) {
            toastr.error(response.message);
            return;
        }
        // This is the up-to-date messages structure serialised from the HTTPActionResponse
        if (angular.isDefined(response.data.messages)) {
            let toastrText = '';
            angular.forEach(response.data.messages, function (message) {
                toastrText += message;
                toastrText += '\n';
            });
            toastr.error(toastrText);
            return;
        }
        if (response.status === 404) {
            msg = `Not Found`;
            toastr.error(msg);
            return;
        }
        if (response.status === 400) {
            if (!angular.isUndefined(response.data.Message)) {
                toastr.error(response.data.Message);
                return;
            }
        }
        // Internal Server error
        if (response.status === 500) {
            // if (!angular.isUndefined(response.data) && !angular.isUndefined(response.data.StackTrace)) {
            //    console.error('Stack Trace', response.data.StackTrace);
            //}
            if (!angular.isUndefined(response.data.ExceptionMessage)) {
                // not visible under a release build
                toastr.error(response.data.ExceptionMessage);
                return;
            }
        }
        toastr.error(msg, title);
    }
    return fac;
});
